import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWRMutation from "swr/mutation";
const updateLead = async (id, formData) =>
  await jwtAxios.patch(`${URL_API.CMS_CUSTOMER_LEADS.UPDATE_CUSTOMER_LEAD}/${id}`, formData);

const useUpdateCustomerLead = () => {
  const fetcher = (_url, { arg }) => updateLead(arg.id, arg.formData);
  return useSWRMutation(URL_API.CMS_CUSTOMER_LEADS.UPDATE_CUSTOMER_LEAD, fetcher);
};

export default useUpdateCustomerLead;
